<div class="body">
  <div class="container">
    <div class="row title-box mt-3">
      <div class="col-12 col-sm-12">
        <h3 class="txtbienvenida">Parametrizar <span class="txtbienvenida-2">
        reportes negativos en centrales de riesgo</span></h3>
      </div>
    </div>
    <div class="row justify-content-md-center">
      <div class="col-12 col-sm-12 mt-3">
        <p class="title-box">*Desde aquí puedes administrar la parametrización de las centrales de riesgo</p>
      </div>
    </div>
    @if (listaParametrosCRCliente.length==0) {
      <form [formGroup]="administrarCentralRiesgoForm">
        <div class="row">
          <div class="col-12 col-sm-6">
            <label for="texto" class="form-label">¿Desea recibir todas las operaciones así estén reportadas negativamente en centrales de
            riesgo?</label>
            <div class="form-check form-check-inline"
              [ngClass]="{'is-invalid':isValidForm('aceptaSolicitudes')}">
              <input class="form-check-input" type="radio" formControlName="aceptaSolicitudes"
                id="aceptaSolicitudes1" [value]="1" (click)="aceptaSolicitudesReportadas(true)">
                <label class="form-check-label" for="inlineRadio1">Sí</label>
              </div>
              <div class="form-check form-check-inline"
                [ngClass]="{'is-invalid':isValidForm('aceptaSolicitudes')}">
                <input class="form-check-input" type="radio" formControlName="aceptaSolicitudes"
                  id="aceptaSolicitudes2" [value]="0" (click)="aceptaSolicitudesReportadas(false)">
                  <label class="form-check-label" for="inlineRadio2">No</label>
                </div>
              </div>
            </div>
            @if (aceptaSolicitudes) {
              <div>
                <div class="col-12 col-sm-12 mt-4">
                  <label style="font-size: large;">Parametrizar centrales de riesgo por sector</label>
                  <div class="table-responsive">
                    <table class="table table-striped table-borderless rounded" id="tablaParametrizarComisiones">
                      <thead class="table_head">
                        <tr>
                          <th scope="col" class="no-styles table-header" id="sector">
                            Sector
                          </th>
                          <th scope="col" class="no-styles table-header" id="aceptaMoras">
                            ¿Acepta todas las moras en este sector?
                          </th>
                          <th scope="col" class="no-styles table-header" id="diasTolerables">
                            Días de mora máximos tolerables
                          </th>
                        </tr>
                      </thead>
                      <tbody id="tbodyCR" formArrayName="configuraciones">
                        @for (item of configuraciones.controls; track item; let i = $index) {
                          <tr id="filaCR"
                            [formGroupName]="i">
                            <td>
                              <div>
                                {{item.get('nombreSector').value}}
                              </div>
                            </td>
                            <td>
                              <div>
                                <select class="form-control" formControlName="aceptacionRiesgo"
                                  required title="Seleccione una opción">
                                  <option value="" selected disabled>Seleccione una opción</option>
                                  <option [value]="true">
                                    Si acepto
                                  </option>
                                  <option [value]="false">
                                    No acepto
                                  </option>
                                </select>
                                <div class="invalid-feedback">
                                  Campo obligatorio
                                </div>
                              </div>
                            </td>
                            <td>
                              <input type="number" class="form-control" formControlName="maximoDias" required
                                appOnlyNumbers min="0" appBloquearPegadoNegativo/>
                                <div class="invalid-feedback">
                                  Campo obligatorio
                                </div>
                              </td>
                            </tr>
                          }
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              }
              <div class="row justify-content-md-center g-3">
                <div class="col-12 col-lg-3 col-md-2 container-btn">
                  <button class="btn btn-primary hvr-shrink" type="submit" (click)="guardarParametrizacionCR()">
                  Guardar parametrización</button>
                </div>
                <div class="col-12 col-lg-3 col-md-2 container-btn">
                  <button class="btn btn-primary hvr-shrink" type="submit" (click)="limpiar()">Limpiar</button>
                </div>
                <div class="col-12 col-md-2 container-btn">
                  <button class="btn  btn-primary hvr-shrink" routerLink="/intermediario/home">
                    Volver
                  </button>
                </div>
              </div>
            </form>
          }
          @if (listaParametrosCRCliente.length>0) {
            <div class="col-12 col-sm-12 mt-4">
              <div class="table-responsive">
                <table class="table table-striped table-borderless rounded" id="tablaParametrizarComisiones">
                  <thead class="table_head">
                    <tr>
                      <th scope="col" class="no-styles table-header" id="sector">
                        Sector
                      </th>
                      <th scope="col" class="no-styles table-header" id="aceptaMoras">
                        ¿Acepta todas las moras en este sector?
                      </th>
                      <th scope="col" class="no-styles table-header" id="diasTolerables">
                        Días de mora máximos tolerables
                      </th>
                    </tr>
                  </thead>
                  <tbody id="tbodyCR">
                    @for (parametro of listaParametrosCRCliente; track parametro; let i = $index) {
                      <tr id="filaCR">
                        <td>
                          {{listaSectoresCR[i]?.nombre}}
                        </td>
                        <td>
                          {{parametro.aceptacionRiesgo == 1? 'Si':'No'}}
                        </td>
                        <td>
                          {{parametro.maximoDias}}
                        </td>
                      </tr>
                    }
                  </tbody>
                </table>
              </div>
              <div class="row justify-content-md-center">
                <div class="col-12 col-lg-3 col-md-2 container-btn">
                  <button class="btn btn-primary hvr-shrink" type="submit" (click)="editarFila()">
                  Editar parametrización</button>
                </div>
              </div>
            </div>
          }
        </div>
        <div class="footer-body"></div>
        <!-- modal editar -->
        <div class="modal fade" id="modal-editar" tabindex="-1" aria-labelledby="editModalLabel" aria-hidden="true"
          data-backdrop="static" data-keyboard="false">
          <div class="modal-dialog modal-dialog-centered">
            <div class="modal-content">
              <div class="modal-header">
                <h5 class="modal-title" id="editModalLabel">EDITAR PARAMETRIZACIÓN CENTRAL RIESGO</h5>
                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close">

                </button>
              </div>
              <form [formGroup]="editarCentralRiesgoForm">
                <div class="container">
                  <div class="col-12 col-sm-12 mt-4">
                    <div class="table-responsive">
                      <table class="table table-striped table-borderless rounded"
                        id="tablaParametrizarComisiones">
                        <thead class="table_head">
                          <tr>
                            <th scope="col" class="no-styles table-header" id="sector">
                              Sector
                            </th>
                            <th scope="col" class="no-styles table-header" id="aceptaMoras">
                              ¿Acepta todas las moras en este sector?
                            </th>
                            <th scope="col" class="no-styles table-header" id="diasTolerables">
                              Días de mora máximos tolerables
                            </th>
                          </tr>
                        </thead>
                        <tbody id="tbodyCR" formArrayName="configuracionesEditar">
                          @for (item of configuracionesEditar.controls; track item; let i = $index) {
                            <tr id="filaCREditar"
                              [formGroupName]="i">
                              <td>
                                <div>
                                  {{listaSectoresCR[i]?.nombre}}
                                </div>
                              </td>
                              <td>
                                <div>
                                  <select class="form-control"
                                    formControlName="aceptacionRiesgo"
                                    [title]="item.get('aceptacionRiesgo').value == true ? 'Sí acepto' : 'No acepto'">
                                    <option [value]="true">
                                      Si acepto
                                    </option>
                                    <option [value]="false">
                                      No acepto
                                    </option>
                                  </select>
                                  <div class="invalid-feedback">
                                    Campo obligatorio
                                  </div>
                                </div>
                              </td>
                              <td>
                                <input type="number" class="form-control" formControlName="maximoDias"
                                  required appOnlyNumbers min="0" appBloquearPegadoNegativo/>
                                </td>
                              </tr>
                            }
                          </tbody>
                        </table>
                      </div>
                    </div>
                    <div class="modal-footer col-12 col-lg-12">
                      <button type="submit" class="btn btn-primary" (click)="confirmarEditarCR()">
                        Guardar cambios
                      </button>
                      <button type="reset" class="btn btn-primary" data-bs-dismiss="modal">
                      Cancelar</button>
                    </div>
                  </div>

                </form>
              </div>
            </div>
          </div>
          <!-- end modal editar -->
          <ngx-spinner type="ball-scale-multiple"></ngx-spinner>
